var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import moment from 'moment';
import ApplicationOrderService from '../../../api/ApplicationOrderService';
var initFormData = {
    type_ids: '',
    time_type: 1,
    s_time: moment().subtract(30, 'days').format('YYYY-MM-DD'),
    e_time: moment().format('YYYY-MM-DD'),
    order_status: [1, 2],
};
var BillHeader = (function (_super) {
    __extends(BillHeader, _super);
    function BillHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = __assign({}, initFormData);
        _this.dateTypeList = [
            { name: '发生日期', id: 1 },
            { name: '制单日期', id: 2 },
            { name: '审核日期', id: 3 },
            { name: '废弃日期', id: 4 },
        ];
        _this.statusList = [
            { name: '全部状态', value: '' },
            { name: '待审核', value: 1 },
            { name: '已审核', value: 2 },
            { name: '已废弃', value: 6 },
        ];
        _this.typeList = [];
        return _this;
    }
    BillHeader.prototype.created = function () {
        this.service = ApplicationOrderService.getInstance();
        this.getTypeList();
    };
    BillHeader.prototype.mounted = function () {
        this.search();
    };
    BillHeader.prototype.getTypeList = function () {
        var _this = this;
        this.service.getTypeOptionList().then(function (res) {
            var data = Array.isArray(res.data.data) ? res.data.data : [];
            _this.typeList = data;
            console.log(_this.typeList);
        });
    };
    BillHeader.prototype.search = function () {
        var filter = __assign({}, this.formData);
        filter.type_ids = filter.type_ids && filter.type_ids.join(',');
        this.$emit('search', filter);
    };
    BillHeader.prototype.reset = function () {
        this.formData = __assign({}, initFormData);
    };
    BillHeader = __decorate([
        Component
    ], BillHeader);
    return BillHeader;
}(Vue));
export default BillHeader;
